import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { WhatsAppButton } from './WhatsAppButton';
import { CartDrawer } from '../../pages/NegozioPage';
import { useCart } from '../../context/CartContext';
import { useSiteSettings } from '../../hooks/useSiteSettings';

export const Layout = ({ children }) => {
  const { cartOpen, closeCart } = useCart();
  const { settings } = useSiteSettings();

  return (
    <div className="min-h-screen flex flex-col bg-[#F9F7F2]">
      <Navbar />
      <main className="flex-grow">{children}</main>
      <Footer />
      <WhatsAppButton />
      <CartDrawer open={cartOpen} onClose={closeCart} whatsappNumber={settings.whatsapp_number} />
    </div>
  );
};
